<template>
  <div class="main-frame">
    <div
      v-if="showMenu('t1')"
      style="padding-left: 10px; padding-right: 10px;"
      class="md-layout md-gutter md-alignment-cener-center"
    >
      <div class="md-layout-item">
        <md-field
          v-if="showAllMenu"
          style="margin-bottom: 10px;"
        >
          <template v-if="catgDepth1.length === 1">
            <span class="md-title">{{ catgTitles.c1 }}</span>
          </template>
          <template v-else>
            <md-select
              v-model="catgDepth1Value"
              name="category_d0"
            >
              <template v-for="tab in catgDepth1">
                <md-option 
                  :key="tab.id"
                  :value="tab.value"
                >
                  {{ tab.title }}
                </md-option>
              </template>
            </md-select>
          </template>
        </md-field>
        <md-field 
          v-else
          style="margin-bottom: 10px;"
        >
          <template v-for="(urlObj, idx) in depthUrls">
            <span :key="idx">            
              <span
                v-if="idx > 0"
                class="md-title"
              >
                &nbsp;>&nbsp;
              </span>
              <template v-if="urlObj.url">
                <a
                  :href="urlObj.url"
                  class="md-title"
                >
                  {{ urlObj.title }}
                </a>              
              </template>
              <template v-else>
                <span class="md-title">
                  {{ urlObj.title }}
                </span>
              </template>
            </span>
          </template>
        </md-field>        
      </div>
      <div 
        v-if="showMenu('t2') && catgDepth1Value != 'all'"
        class="md-layout-item"
      >
        <md-field style="margin-bottom: 10px;">
          <md-select
            v-model="catgDepth2Value"
            name="category_d1"
          >
            <template v-for="tab in catgDepth2">
              <md-option
                :key="tab.id"
                :value="tab.value"
              >
                {{ tab.title }}
              </md-option>
            </template>
          </md-select>
        </md-field>
      </div>
    </div>
    <md-tabs
      v-if="showMenu('t3') && catgDepth1Value != 'all'"
      :md-active-tab="catgDepth3Value"
      @md-changed="onDepth3Changed"
    >
      <template v-for="tab in catgDepth3">
        <md-tab
          :id="tab.value"
          :key="tab.id"
          :md-label="tab.title"
        >
          <StepDesc 
            v-if="tab.infos && tab.infos.length"
            :tab-infos="tab.infos"
          />
        </md-tab>
      </template>      
    </md-tabs>
    <div v-if="showMenu('t4')">
      <template v-for="(tab, idx) in catgDepth3">
        <StepDesc 
          v-if="tab.value == catgDepth3Value && tab.infos && tab.infos.length"
          :key="idx"
          :tab-infos="tab.infos"
        />
      </template>      
    </div>
    <div :class="'book-list-frame' + (baseCond.b || baseCond.k ? ' centered' : '')">
      <template v-for="book in books">
        <BookCard 
          v-if="existLang(book.data)"
          :key="book.id"
          :book-info="book"
          :is-prod-page="cond.b || cond.k ? true : false"
          :video-play.sync="playVideoUrl"
        />
      </template>  
      <md-empty-state
        v-if="bookEmpty"
        md-label="책이 없습니다."
      />
    </div>
    <md-dialog
      :md-active.sync="showDialog"
      class="video-dialog"
    >
      <iframe
        :src="dialogVideoUrl"
        style="width: 100%; height: 100%;"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
      />
    </md-dialog>
  </div>
</template>

<script>
import globals from '../globals'

const GET_CHLID_ITEMS = function (pId, depth, items) {
  let _loop = function (items) {
    let findItems
    if (items[0].depth === depth - 1) {
      if (pId === 0) {
        findItems = items[0].items
      }
      else {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === pId) {
            findItems = items[i].items
            break
          }
        }
      }
    }
    else if (items[0].depth < depth - 1) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].items && items[i].items.length) {
          findItems = _loop(items[i].items)
        }
        if (findItems) break
      }
    }
    return findItems
  }

  let retList = []
  let childItems = _loop(items)
  if (childItems && childItems.length) {
    childItems.forEach(item => {
      retList.push({
        id: item.id,
        title: item.title,
        value: item.value,
        infos: item.infos
      })
    })
  }
  return retList
}

const GET_DEPTH_LIST = function (pList, pValue, depth, allList) {
  if (!allList.length) return []
  let depthId
  for (var i = 0; i < pList.length; i++) {
    if (pValue == pList[i].value) {
      depthId = pList[i].id
      break
    }
  }
  let retList = depthId ? GET_CHLID_ITEMS(depthId, depth, allList) : []
  if (retList.length) retList.unshift({title: 'All', value: 'all'})
  return retList
}

export default {
  name: 'TabRouter',

  data: () => ({
    glang: 'ko',
    showAllMenu: false,
    catgTitles: {},
    cond: {},
    baseCond: {},
    catgs: [],
    depth1List: [],
    depth2List: [],
    depth3List: [],
    books: [],
    bookEmpty: false,
    catgDepth1Value: '',
    catgDepth2Value: '',
    catgDepth3Value: '',
    depthUrls: [],
    playVideoUrl: '',
    showDialog: false,
    dialogVideoUrl: '',
    zoomRatio: 1
  }),

  computed: {
    catgDepth1 () {
      if (!this.catgs.length) return []      
      let list = GET_CHLID_ITEMS(0, 1, this.catgs)
      if (list.length > 1 || this.baseCond.c1 == 'all') {
        list.unshift({title: 'All', value: 'all'})
      }
      return list
    },
    catgDepth2 () {
      return GET_DEPTH_LIST(this.catgDepth1, this.catgDepth1Value, 2, this.catgs)
    },
    catgDepth3 () {
      return GET_DEPTH_LIST(this.catgDepth2, this.catgDepth2Value, 3, this.catgs)
    }
  },

  watch: {
    playVideoUrl () {
      // show dialog
      if (this.playVideoUrl) {
        console.error('video url = ', this.playVideoUrl)
        this.showDialog = true

        let cnt = -1
        let resize = () => {
          setTimeout(() => {
            cnt += 1
            if (cnt > 20) {
              this.showDialog = false
              return
            }
            let dialogTag = document.querySelector('.video-dialog')
            if (dialogTag) {
              // 1920 * 1080 size video
              dialogTag.style.width = ((window.innerWidth * 0.9) / this.zoomRatio) + 'px'
              dialogTag.style.height = ((window.innerWidth * 0.9 * (1080/1920)) / this.zoomRatio)+ 'px'
              dialogTag.style.minWidth = dialogTag.style.width
              this.dialogVideoUrl = this.playVideoUrl
              this.playVideoUrl = ''
            }
            else {
              resize()
            }
          }, 100)
        }
        resize()
      }
    },
    catgDepth1Value () {
      if (!this.catgDepth1Value) return
      
      if (this.cond.c1 == this.catgDepth1Value) {
        if (!this.catgDepth2Value || (this.cond.c2 && this.catgDepth2Value != this.cond.c2)) {
          this.catgDepth2Value = this.cond.c2 || 'all'
        }
        else if (!this.catgDepth3Value || (this.cond.c3 && this.catgDepth3Value != this.cond.c3)) {
          this.catgDepth3Value = this.cond.c3 || 'all'
        }
        else {
          this.cond.c2 = 'all'
          this.cond.c3 = 'all'
          this.getBookList()
        }
      }
      else {
        this.cond.c1 = this.catgDepth1Value
        if (this.catgDepth2Value != 'all') {
          this.catgDepth2Value = 'all'
        }
        else if (this.catgDepth3Value != 'all') {
          this.catgDepth3Value = 'all'
        }
        else {
          this.cond.c2 = 'all'
          this.cond.c3 = 'all'
          this.getBookList()
        }
      }
    },
    catgDepth2Value () {
      if (!this.catgDepth2Value) return

      if (this.cond.c2 == this.catgDepth2Value) {
        if (!this.catgDepth3Value || (this.cond.c3 &&  this.catgDepth3Value != this.cond.c3)) {
          this.catgDepth3Value = this.cond.c3 || 'all'
        }
        else {
          this.getBookList()
        }
      }
      else {
        this.cond.c2 = this.catgDepth2Value
        if (this.catgDepth3Value != 'all') {
           this.catgDepth3Value = 'all'
        }
        else {
          this.cond.c3 = 'all'
          this.getBookList()
        }
      }
    },
    catgDepth3Value () {
      if (!this.catgDepth3Value) return
      this.cond.c3 = this.catgDepth3Value
      this.getBookList()
    }
  },

  created () {
    let uri = window.location.href.split('?')
    if (uri.length == 2) {
      let vars = uri[1].split('&')
      let tmp = '', cond = ''
      vars.forEach(v => {
        tmp = v.split('=')
        if(tmp.length == 2) {
          if (tmp[0] == 'ln') {
            this.glang = tmp[1]
          }
          else if (tmp[0] == 'full') {
            this.showAllMenu = tmp[1].toLowerCase() === 'y'
          }
          else if (tmp[0] == 'c') {
            cond = tmp[1].split('_')
            cond.forEach((v, idx) => {
              if (idx == 3) {
                // book user key must be string
                this.cond.k = '' + v
              }
              else {
                // category id
                this.cond['c' + (idx + 1)] = v
                if (idx === 2) this.hideT2 = true
                if (idx === 3) this.hideT3 = true
              }
            })
          }
          else if (tmp[0] == 'b') {
            this.cond.b = tmp[1]
          }
        }
      })
    }

    Object.assign(this.baseCond, this.cond);

    if (this.cond.b || this.cond.k) {
      this.getBookList()
      this.makeZoom()
    }
    else {
      if (!this.cond.c1) {
        this.cond.c1 = 'all'
        this.baseCond.c1 = 'all'
        this.showAllMenu = true
      }
      this.getCategories()
    }    
  },

  mounted () {
    if (this.baseCond.b || this.baseCond.k) {
      window.addEventListener('resize', this.onResponsiveInverted)
    }
  },

  methods: {
    makeZoom () {
      let ratio = window.innerWidth * 0.85 / 320
      if (ratio < 1) ratio = window.innerWidth / 320
      document.querySelector('body').style.zoom = ratio

      this.zoomRatio = ratio
    },
    showMenu (type) {
      let ret = false
      if (this.baseCond.b || this.baseCond.k) {
        ret = false
      } 
      else if (type == 't4') {
        // tab box without toolbox
        ret = this.baseCond.c3  && !this.showAllMenu ? true : false
      }
      else if (this.showAllMenu) {
        ret = true
        if (type == 't3') {
          ret = this.catgDepth3.length ? true : false
        }
      }
      else {
        if (type == 't1') {
          // category depth 1
          ret = true
        }
        else if (type == 't2') {
          // category select box
          ret = false
        }
        else if (type == 't3') {
          // tab box with toolbox
          ret = this.baseCond.c3 ? false : true
        }
      }
      return ret
    },
    removeQuote (str) {
      if (str && (str.charAt(0) === '"' || str.charAt(0) === "'")) {
        str = str.substring(1)
      }
      if (str && (str.charAt(str.length - 1) === '"' || str.charAt(str.length - 1) === "'")) {
        str = str.substring(0, str.length - 1)
      }
      return str
    },
    async getCategories () {
      let cond = this.cond
      if (!cond || !cond.c1) return

      cond.state = 'Y'
      cond.c2 = cond.c2 || 'all'
      cond.c3 = cond.c3 || 'all'

      this.$http.get('category/' + JSON.stringify({c1:cond.c1}))
        .then(res => {
          this.catgs = res.data
          this.parseCategoryData(res.data)
          this.setCategoryUrls()

          this.catgDepth1Value = cond.c1
        })
        .catch(error => {
          console.log('get category list error!!', error)
        })
    },
    async getBookList () {
      this.books = [];
      let cond = this.cond
      if (!cond) return
      cond.state = 'Y'
      this.$http.get('book/' + JSON.stringify(cond))
        .then(res => {
          this.bookEmpty = true
          res.data.forEach((element, idx) => {
            this.addBookData(element, idx)
            this.bookEmpty = false
            this.cond.c1 = ''
            this.cond.c2 = ''
            this.cond.c3 = ''
          })
        })
        .catch(error => {
          this.bookEmpty = true;
          console.log('get book list error!!', error);
        })
    },
    parseCategoryData (_list) {
      var _loop = (list, parent) => {
        for (var i=0; i<list.length; i++) {
          if (list[i].bdata) {
            if (typeof list[i].bdata == 'string') {
              list[i].bdata =  JSON.parse(this.removeQuote(list[i].bdata))
            }

            if (list[i].bdata[this.glang]) {
              list[i].infos = list[i].bdata[this.glang].infos
              list[i].title = list[i].bdata[this.glang].title
            }
          }
          if (list[i].depth === 1) {
            if (this.baseCond.c1 == 'all') {
              this.catgTitles.c1 = 'All'
            }
            else {
              this.catgTitles.c1 = list[i].title
            }
          }
          else if (list[i].depth > 1) {
            if (!this.showAllMenu && 
              this.cond.c2 == list[i].value ||
              this.cond.c3 == list[i].value) {
              this.catgTitles['c' + list[i].depth] = list[i].title
            }
          }

          if (list[i].items && list[i].items.length) {
            _loop(list[i].items, list[i].value)
          }
        }        
      }

      _loop(_list);
    },
    addBookData (item, idx) {
      let nItem = {};
      let bData = {}
      item.bdata = this.removeQuote(item.bdata)
      try {
        nItem.data = item.bdata ? JSON.parse(item.bdata) : {}
      }
      catch (e) {
        console.error(e)
      }

      nItem.id = item.id
      nItem.userId = item.user_key
      nItem.catgId = item.category_id
      
      nItem.curLang = this.glang
      nItem.langs = []

      if (nItem.data.ko && nItem.data.ko.title) nItem.langs.push('ko')
      if (nItem.data.en && nItem.data.en.title) nItem.langs.push('en')
      if (nItem.data.jp && nItem.data.jp.title) nItem.langs.push('jp')

      this.books.push(nItem)
    },
    onDepth3Changed (value) {
      this.catgDepth3Value = value      
    },
    setCategoryUrls () {
      let urls = this.depthUrls

      if (this.showMenu('t1')) {
        if (this.baseCond.c2) {
          let url = globals.get('cliSvrUrl') + '?c='
          // c1 url
          url += this.baseCond.c1
          if (this.baseCond.c2) {
            urls.push({url, title: this.catgTitles.c1})
          }
          if (this.baseCond.c3) {
            // add c2 url
            url += '_' + this.baseCond.c2
            urls.push({url, title: this.catgTitles.c2})            
            urls.push({title: this.catgTitles.c3})
          }
          else if (this.baseCond.c2) {
            urls.push({title: this.catgTitles.c2})
          }
          else if (this.baseCond.c1) {
            urls.push({title: this.catgTitles.c1})
          }
        }
        else {
          urls.push({title: this.catgTitles.c1})
        }
      }
    },
    onResponsiveInverted () {
      this.makeZoom()
    },
    existLang (bookData) {
      let exist = false
      if (bookData[this.glang]) {
        for (var k in bookData[this.glang]) {
          if (bookData[this.glang][k]) {
            exist = true
            break
          }
        }
      }
      return exist
    }
  }
}
</script>

<style>
.main-frame {
  max-width: 1000px;
  margin: auto;
}
.book-list-frame {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 5px;
}
.centered {
  justify-content: center;
}
.maru-logo {
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  height: 50px;
  background:url('../assets/imgs/Marubooks_logo.png') no-repeat center;
  background-size: contain;
}
</style>